import { observe } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { IncidentDataParser } from ".";
export class IncidentsParser {
    constructor(retriever) {
        this.retriever = retriever;
        this.incidentsData = [];
        this.participantsNames = {};
        this.participantMapping = {};
        this.sendUpdatedIncidentsTimeout = {};
        this.disposeIncidents = () => { };
        this.sendUpdatedIncidents = this.sendUpdatedIncidents.bind(this);
        this.updateParticipantNames = this.updateParticipantNames.bind(this);
        this.messageBus = retriever.messageBus;
    }
    activate() {
        this.disposeIncidents = observe(this.retriever, "incidents", (change) => {
            this.updateIncidents(change.newValue);
        });
        this.retriever.activate();
        this.sendUpdatedIncidentsTimeout = setTimeout(this.sendUpdatedIncidents, 60000);
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.participants.update, this.updateParticipantNames);
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.incident.request, this.sendUpdatedIncidents);
    }
    deactivate() {
        this.disposeIncidents();
        this.retriever.deactivate();
        clearTimeout(this.sendUpdatedIncidentsTimeout);
        this.incidentsData = [];
        this.participantsNames = {};
        this.participantMapping = {};
        this.sendUpdatedIncidentsTimeout = {};
    }
    updateParticipantNames(message) {
        if (message.data[0] && message.data[0].participants) {
            this.participantsNames = message.data[0].participants;
            this.incidentsData.forEach(element => element.participant = IncidentDataParser.getParticipantName(this.participantsNames, this.participantMapping[element.id]));
            this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.incident.update, { incidents: this.incidentsData });
        }
    }
    updateIncidents(incidents) {
        this.incidentsData = this.addIncidents(this.incidentsData, incidents);
        this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.incident.update, { incidents: this.incidentsData });
    }
    /**
     * @param parsedIncidents - array containing current incidents parsed to IncidentData
     * @param incidents - array containing, newly received incidents
     * @returns new array which contains the new incidents parsed to incidentData and appended to the old incidents
     */
    addIncidents(parsedIncidents, incidents) {
        return this.parseNewIncidents(incidents).concat(parsedIncidents.slice());
    }
    parseNewIncidents(incidents) {
        return incidents
            .map((incident) => {
            this.participantMapping[`${incident.id}`] = `${incident.participantMapping}`;
            return IncidentDataParser.parse(incident, this.participantsNames);
        });
    }
    sendUpdatedIncidents() {
        this.incidentsData.forEach(element => element.minute = IncidentDataParser.getUpdateCurrentMinute(element.incidentActualTime));
        this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.incident.update, { incidents: this.incidentsData });
        this.sendUpdatedIncidentsTimeout = setTimeout(this.sendUpdatedIncidents, 60000);
    }
}
//# sourceMappingURL=IncidentsParser.js.map